import httpClient from "@/config/httpClient";
import { editedEntityStore, uiStore, userStore } from "@/mobx/rootStore";
import { routesList } from "@/routesList";
import { endpoints } from "@/utils/common/requests/endpoints";

export async function logout({ redirect = routesList.login.path } = {}) {
	await httpClient.post(endpoints.auth.POST_LOGOUT());

	userStore.reset();
	uiStore.reset();
	editedEntityStore.reset();

	if (redirect) {
		window.location.href = redirect;
	}
}
